import { render } from "./ListBerita.vue?vue&type=template&id=3c0b2b14&scoped=true"
import script from "./ListBerita.vue?vue&type=script&lang=js"
export * from "./ListBerita.vue?vue&type=script&lang=js"

import "./ListBerita.vue?vue&type=style&index=0&id=3c0b2b14&scoped=true&lang=css"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0b2b14"]])

export default __exports__